import React, { useEffect } from 'react'
import { BodyText, CaptionText, Card, Icon } from '@paypalcorp/pp-react'
import PreApprovalBadge from '../PreApprovalBadge'
import { preApprovalCategory } from 'ppbl/utils/constants'
import { getBannerContent, showBanner } from './__utils__'
import { trackPage } from 'ppbl/utils/fpti-helper'
import { merge } from 'lodash-es'
import { useApplicationContext } from 'ppbl/hooks'
import clientLogger from 'ppbl/utils/client-logger'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import './index.css'

type PreApprovalBannerProps = {
  approvalCategory: preApprovalCategory
  expiryDate: string
}

const fptiData = {
  page: 'preApprovalBanner',
  event_name: FPTI_EVENTS.PAGE.PREAPPROVAL_BANNER,
}

const PreApprovalBanner: React.FC<PreApprovalBannerProps> = ({
  approvalCategory,
  expiryDate,
}) => {
  const bannerContent = getBannerContent(approvalCategory, expiryDate)
  const { data } = useApplicationContext()

  useEffect(() => {
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
    clientLogger.info(
      'Preapproval Banner is loaded',
      data?.applicationMetaData?.applicationId,
    )
  }, [])

  if (!bannerContent) {
    return null
  }

  const isBanner = showBanner()
  const { title, subtitle, badgeText } = bannerContent

  return (
    <>
      {isBanner ? (
        <div>
          <Card className="preApprovalBanner">
            <div>
              <Icon name="loans" width="3rem" height="3rem" color="success" />
            </div>
            <div className="preApprovalBannerTextWrapper">
              <BodyText strong>{title}</BodyText>
              <CaptionText>{subtitle}</CaptionText>
              <div>
                <PreApprovalBadge>{badgeText}</PreApprovalBadge>
              </div>
            </div>
          </Card>
        </div>
      ) : (
        <div>
          <PreApprovalBadge>{badgeText}</PreApprovalBadge>
        </div>
      )}
    </>
  )
}

export default PreApprovalBanner
